// @vue/component
import HelpPageForm from './HelpPageForm';
import HelpPageSupervisor from './HelpPageSupervisor';


export default {
  name: 'HelpPage',
  components: { HelpPageForm, HelpPageSupervisor },
  data() {
    return {
      supervisor: Object,
      isLoading: false,
    };
  },

  async created() {
    this.isLoading = true;
    await this.$store.dispatch('client/projects/getList');
    const projects = this.$store.getters['client/projects/list'].records.map(el => el.uuid);
    await this.$store.dispatch('user/supervisors/getSupervisorsBelongsToUser', projects);
    this.supervisor = this.$store.getters['user/supervisors/supervisorsBelongsToUser'];
    this.isLoading = false;
  },
};
